<template>
  <div class="registration_box">
    <div class="outside_box">
      <div class="form_box" v-if="!isLoading">
        <img src="https://pub-files.jinshuju.net/hi/20171122094544_c8dd63" alt="" class="formbanner">
        <div class="formcontent" v-if="!isSuccess">
          <form action="">
            <div class="title">高山书院（GASA）2020级入学申请表</div>
            <div class="desc first"><p>No Education Only Learning<br>没有受教，求知探索。<br>请您如实填写以下信息，高山书院（GASA）将对您的所填信息严格保密。</p></div>
            <div class="desc"><b>高山书院（GASA）2020级秋季班招生人数为30人，报名额满即止。</b><p style="font-family:'宋体';color:#696969;">课程报名采取推荐制，申请人需要获得至少一封推荐信。（点击获取<router-link to="/recommend">推荐表</router-link>）</p></div>
            <div class="desc"><b>申请流程：</b><p style="font-size:16px;color:#000;">1. 申请- 提交入学申请表
              <br>2. 审核- 高山书院校方审核
              <br>3. 一面- 高山书院创办人文厨面试
              <br>4. 二面- 高山书院校董或班委面试
              <br>5. 录取- 收到录取通知书</p></div>
            <div class="desc" style="font-size:16px;color:#000;">如您有任何问题，请联系：<br>E-mail：<b style="font-size:14px;">info@gasauniversity.org</b>&nbsp;&nbsp;&nbsp;微信：GASA2017</div>
            <div class="desc lastdesc"><b style="font-size:14px;">关于高山书院（GASA），长按识别下方二维码，了解更多。</b>
              <a href="https://pub-files.jinshuju.net/di/20181121133721_8c8170" style="display:block;text-align:center;">
                <img alt="" width="149" height="147" src="https://pub-files.jinshuju.net/di/20181121133721_8c8170">
              </a>
            </div>
            <div class="borderline"></div>
            <div class="form_list">
              <div class="part firstPart">
                <div class="form_group">
                  <b class="must">姓名</b>
                  <input type="text" v-model="registerData.name" class="text" name="name" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('name')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">性别</b>
                  <label><input type="radio" v-model="registerData.sex" name="sex" v-validate="'required'" value="男">男</label>
                  <label><input type="radio" v-model="registerData.sex" name="sex" v-validate="'required'" value="女">女</label>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('sex')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">邮箱</b>
                  <span class="formicon glyphicon glyphicon-envelope" aria-hidden="true"></span>
                  <input type="text" v-model="registerData.email" class="text" name="email" v-validate="'required'" style="padding-left:34px;">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('email')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">微信号</b>
                  <input type="text" v-model="registerData.wechat" class="text" name="wechat" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('wechat')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">手机</b>
                  <span class="formicon glyphicon glyphicon-phone" aria-hidden="true"></span>
                  <input type="text" v-model="registerData.tel" class="text" name="tel" v-validate="'required'" style="padding-left:34px;">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('tel')">请填写此项</p>
                </div>
                <div class="form_group birth_group">
                  <b class="must">出生年月日</b>
                  <span class="formicon glyphicon glyphicon-calendar" aria-hidden="true" style="font-size:12px;color:#ccc;"></span>
                  <input type="text" readonly @click.stop="show=!show" :model="current | dateFormat" :value="current | dateFormat" class="text" name="birth" v-validate="'required'" placeholder="年-月-日">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('birth')">请填写此项</p>
                  <div
                    ref="agm-datepicker"
                    class="agm-datepicker">
                    <div
                      :class="{active: show}"
                      class="agm-input"
                      >
                      <input
                        type="text"
                        readonly
                        style="border:none;">
                    </div>
                    <div
                      v-if="show"
                      :class="{positionTop:positionTop}"
                      class="agm-datepicker-wrap">
                      <div
                        class="agm-datepicker-header">
                        <span
                          v-if="!selectMonth"
                          class="agm-datepicker-header-btn agm-datepicker-header-btn-pre"
                          @click.stop="switchYear(-1)">&lt;&lt;</span>
                        <span
                          v-if="!selectMonth && !selectYear"
                          class="agm-datepicker-header-btn agm-datepicker-header-btn-pre"
                          @click.stop="switchMonth(-1)">&lt;</span>
                        <span class="agm-datepicker-header-btn-day">
                          <span
                            class="agm-datepicker-header-btn"
                            @click.stop="openSelectYear">{{ select.year }}年 </span>
                          <span
                            class="agm-datepicker-header-btn"
                            @click.stop="openSelectMonth">{{ select.month }}月</span>
                        </span>
                        <span
                          v-if="!selectMonth"
                          class="agm-datepicker-header-btn agm-datepicker-header-btn-next"
                          @click.stop="switchYear(1)">&gt;&gt;</span>
                        <span
                          v-if="!selectMonth && !selectYear"
                          class="agm-datepicker-header-btn agm-datepicker-header-btn-next"
                          @click.stop="switchMonth(1)">&gt;</span>
                      </div>
                      <div class="agm-datepicker-content">
                        <table>
                          <thead>
                            <th style="text-align:center;">日</th>
                            <th style="text-align:center;">一</th>
                            <th style="text-align:center;">二</th>
                            <th style="text-align:center;">三</th>
                            <th style="text-align:center;">四</th>
                            <th style="text-align:center;">五</th>
                            <th style="text-align:center;">六</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(week,index) of list"
                              :key="'week_'+index">
                              <td
                                v-for="(weekday,idx) of week"
                                :key="'weekday_'+index+idx"
                                :class="{
                                  'flag': weekday.flag,
                                  'active': !weekday.flag && weekday.text == current.date
                                && select.month == current.month && select.year == current.year}"
                                @click="pick(weekday)">
                                {{ weekday.text }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          v-if="selectYear"
                          class="agm-date-picker-year-panel">
                          <div class="panel-list">
                            <div
                              v-for="(y, index) of years"
                              :key="'year_'+index"
                              class="panel-item">
                              <div
                                :class="{active: y===select.year}"
                                class="panel-item-inner"
                                @click.stop="pickYear(y)">{{ y }}</div> 
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="selectMonth"
                          class="agm-date-picker-year-panel">
                          <div class="panel-list">
                            <div
                              v-for="(m, index) of months"
                              :key="'month_'+index"
                              class="panel-item">
                              <div
                                :class="{active: (index+1)===select.month}"
                                class="panel-item-inner"
                                @click.stop="pickMonth(index+1)">{{ m }}</div> 
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form_group">
                  <b>助理联系方式</b>
                  <input type="text" v-model="registerData.asstel" class="text" name="asstel">
                </div>
              </div>
              <div class="borderline"></div>
              <div class="part secondPart">
                <b class="modelTitle">二. 教育经历<span style="display:block;color:#666;font-size:14px;font-weight:300;">请填写最高的一段教育经历</span></b>
                <div class="form_group four_group">
                  <b class="must">学校名称</b>
                  <input type="text" v-model="registerData.schoolname" class="text" name="schoolname" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('schoolname')">请填写此项</p>
                </div>
                <div class="form_group four_group">
                  <b class="must">学历</b>
                  <input type="text" v-model="registerData.xl" class="text" name="xl" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('xl')">请填写此项</p>
                </div>
                <div class="form_group four_group">
                  <b class="must">专业</b>
                  <input type="text" v-model="registerData.zy" class="text" name="zy" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('zy')">请填写此项</p>
                </div>
                <div class="form_group four_group">
                  <b class="must">起止时间</b>
                  <input type="text" v-model="registerData.qzsj" class="text" name="qzsj" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('qzsj')">请填写此项</p>
                </div>
                <div class="form_group" style="width:100%;">
                  <b>如您参加过同类的创业培训课程，请告诉我们。</b>
                  <input type="text" v-model="registerData.cy" class="text" name="cy">
                </div>
              </div>
              <div class="borderline"></div>
              <div class="part thirdPart">
                <b class="modelTitle">三. 职业信息</b>
                <div class="form_group">
                  <b class="must">您所在的公司或机构名称？</b>
                  <input type="text" v-model="registerData.company" class="text" name="company" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('company')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">您的职务</b>
                  <input type="text" v-model="registerData.title" class="text" name="title" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('title')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="modelTitle">公司介绍相关文件<span style="display:block;color:#666;font-size:14px;font-weight:300;">公司简介或商业计划书等有助于校方深入了解贵司的相关文件（最多上传三个文件，每个文件大小不超过10M，文件过大请打包压缩上传）</span></b>
                  <div class="dropbox p-3">
                    <h2 class="text-center">+ 点击选择上传文件</h2>
                    <input type="file" class="text" name="file" @change="uploadFile2" ref="files">
                    <div class="file_box" v-for="(file, index) in registerData.files" :key="index">
                      <div class="close" @click="deleteFile(index)">x</div>
                      <h5 class="mt-0">{{ file.name }}</h5>
                      <div class="progress">
                        <div :class="file.uploadPercentage === 100 ? 'progress-bar progress-bar-striped progress-success' : 'progress-bar progress-bar-striped'" :style="{ width: file.uploadPercentage+'%' }"></div>
                      </div>
                    </div>
                  </div>
                  <!-- <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('file')">请填写此项</p> -->
                </div>
              </div>
              <div class="borderline"></div> 
              <div class="part forthPart">
                <b class="modelTitle">四. 推荐信<span style="display:block;color:#666;font-size:14px;font-weight:300;">课程报名采取推荐制，申请人需要获得至少一封来自高山书院校董或往期校友的推荐信。
                  <br>请推荐人填写此<router-link to="/recommend">推荐表</router-link>完成申请</span></b>
                <div class="form_group">
                  <b class="must">推荐人姓名</b>
                  <input type="text" v-model="registerData.tjname" class="text" name="tjname" v-validate="'required'">
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('tjname')">请填写此项</p>
                </div>
              </div>
              <div class="borderline"></div>
              <div class="part fifthPart">
                <b class="modelTitle">五. 高山书院五问</b>
                <div class="form_group">
                  <b class="must">目前为止在生活和事业中取得的最大成就是什么？期待在哪些方面取得突破性进展？</b>
                  <textarea v-model="registerData.achievement" class="text" name="achievement" v-validate="'required'"></textarea>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('achievement')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">如果不从事目前的工作，您最想体验什么样的生活？</b>
                  <textarea v-model="registerData.life" class="text" name="life" v-validate="'required'"></textarea>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('life')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">今年，您最想见到的3个人是谁？最近看过最有意思的三本书是？</b>
                  <textarea v-model="registerData.book" class="text" name="book" v-validate="'required'"></textarea>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('book')">请填写此项</p>
                </div>
                <div class="form_group">
                  <b class="must">请简要描述个人和事业30年后要实现的目标</b>
                  <textarea v-model="registerData.target" class="text" name="target" v-validate="'required'"></textarea>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('target')">请填写此项</p>
                </div>
                <div class="form_group check_group">
                  <b class="must">你的英语水平如何？</b>
                  <div>
                    <input type="checkbox" name="englishLevel" v-validate="'required'" v-model="registerData.englishLevel" value="高级">
                    <label for="高级">高级</label>
                  </div>
                  <div>
                    <input type="checkbox" name="englishLevel" v-validate="'required'" v-model="registerData.englishLevel" value="中级">
                    <label for="中级">中级</label> 
                  </div>
                  <div>
                    <input type="checkbox" name="englishLevel" v-validate="'required'" v-model="registerData.englishLevel" value="初级">
                    <label for="初级">初级</label>
                  </div>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('englishLevel')">请填写此项</p>
                </div>
                <div class="form_group check_group">
                  <b class="must">你从什么渠道了解到高山书院的？ (最少选1项)</b>
                  <div>
                    <input type="checkbox" name="way" v-validate="'required'" v-model="registerData.way" value="朋友推荐">
                    <label for="朋友推荐">朋友推荐</label> 
                  </div>
                  <div>
                    <input type="checkbox" name="way" v-validate="'required'" v-model="registerData.way" value="微信公众号">
                    <label for="微信公众号">微信公众号</label> 
                  </div>
                  <div>
                    <input type="checkbox" name="way" v-validate="'required'" v-model="registerData.way" value="高山书院官网">
                    <label for="高山书院官网">高山书院官网</label>
                  </div>
                  <div>
                    <input type="checkbox" name="way" v-validate="'required'" v-model="registerData.way" value="今日头条">
                    <label for="今日头条">今日头条</label>
                  </div>
                  <div>
                    <input type="checkbox" name="way" v-validate="'required'" v-model="registerData.way" value="其他（微博、知乎等）">
                    <label for="其他（微博、知乎等）">其他（微博、知乎等）</label>
                  </div>
                  <p class="warnname" style="font-size:14px;margin-bottom:0;color:#f5222d;" v-show="errors.has('way')">高山书院官网</p>
                </div>
              </div>
              <div class="borderline"></div>
            </div>
          </form>
          <div class="submit" >
            <input type="submit" value="提交" @click="register">
          </div>
        </div>
        <div class="submitSuccess" v-else>
          <div>提交成功</div>
        </div>
      </div>
      <div v-else class="form_box loading_box">
        <img style="width:300px;margin:0 auto;display:block;" src="@/assets/images/load2.gif" alt="">
        <p style="text-align:center;">提交中，请耐心等候......</p>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "registration.page.less";
@import "rili.page.less";
</style>
<script>
import axios from 'axios'
export default {
  filters: {
    // 日期格式过滤器
    dateFormat (val) {
      if (!val) {
        return ''
      }
      return `${val.year}-${val.month}-${val.date}`.replace(/\d+/g, a => {
        return a.length === 4 ? a : a.length === 2 ? a : '0' + a
      })
    }
  },
  inheritAttrs: false,
  props: {
    moment: {
      type: Number,
      default () {
        return new Date().getTime()
      }
    }
  },
  data () {
    return {
      isSuccess: false,
      isLoading: false,
      registerData: {
        name: '',
        sex: '',
        email: '',
        wechat: '',
        tel: '',
        // 生日数据为下方current
        asstel: '',
        schoolname: '',
        xl: '',
        zy: '',
        qzsj: '',
        cy: '',
        company: '',
        title: '',
        files: [],
        filesUrl: [],
        tjname: '',
        achievement: '',
        life: '',
        book: '',
        target: '',
        englishLevel: [],
        way: []
      },
      show: false, // 控制日历面板的显示与隐藏
      selectYear: false, // 控制年份的面板的显示和隐藏
      selectMonth: false, // 控制月份的面板的显示和隐藏
      positionTop: false, // 控制面板显示方向
      current: '', // 已选择的日期时间。yyyy-MM-dd
      select: {
        // 已选择的日期对象
        year: '',
        month: '',
        date: '',
        day: ''
      },
      currentMonthFirstDay: null, // 当前月的1号属于星期几
      currentMonthEndDate: null, // 当前月的最后一天是几号
      currentMonthEndDay: null, // 当前月的最后一天属于星期几
      lastMonthEndDate: null, // 上个月的最后一天是几号
      list: [], // 日历的二维数组
      years: [], // 1900-2100
      months: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
      ]
    }
  },
  watch: {
    select: {
      handler (newVal) {
        let pre
        if (newVal.month === 1) {
          pre = new Date(newVal.year - 1, 12, 0)
        } else {
          pre = new Date(newVal.year, newVal.month - 1, 0)
        }
        this.lastMonthEndDate = pre.getDate()
        // 获取日历排表
        this.getDateList()
      },
      deep: true
    },
    // 打开年份选择器的时候使当前年份、月份出现在窗口顶部
    selectYear (newVal) {
      if (newVal) {
        this.years = []
        this.$nextTick(() => {
          let year = this.select.year
          let startYear = ((year / 10) | 0) * 10
          // 获得年份列表： 1900-2100
          for (let i = startYear; i < startYear + 10; i++) {
            this.years.push(i)
          }
        })
      }
    },
    show (newVal) {
      if (newVal) {
        this.checkOffsetBottom()
      }
    }
  },
  mounted: function () {
    var dropbox = document.querySelector('.dropbox')
    // console.log(dropbox)
    dropbox.addEventListener('dragenter', this.onDrag, {passive: false})
    dropbox.addEventListener('dragover', this.onDrag, {passive: false})
    dropbox.addEventListener('drop', this.onDrop, {passive: false})
  },
  created () {
    this.transform(this.moment)
    this.complete()
    const date = new Date()
    let year = date.getFullYear()
    let startYear = ((year / 10) | 0) * 10
    // 获得年份列表： 1900-2100
    for (let i = startYear; i < startYear + 10; i++) {
      this.years.push(i)
    }
  },
  methods: {
    /* 将时间转化为具体的 年、月、日、星期 */
    transform (time) {
      const date = new Date(time)
      this.select.year = date.getFullYear()
      this.select.month = date.getMonth() + 1
      this.select.date = date.getDate()
      this.select.day = date.getDay()
      this.currentMonthFirstDay = new Date(
        this.select.year,
        this.select.month - 1,
        1,
        0
      ).getDay()
      this.currentMonthEndDate = new Date(
        this.select.year,
        this.select.month,
        0
      ).getDate()
      this.currentMonthEndDay = new Date(
        this.select.year,
        this.select.month,
        0
      ).getDay()
    },
    /* 计算出日历列表，二维数组 第一层为星期，第二层为每星期的第几天 */
    getDateList () {
      this.list = []
      // 获取日历第一行的数据（需加上第一个星期中所包含上个月的几天）
      let temp = this.lastMonthEndDate - (this.currentMonthFirstDay - 1)
      let list = this.numberList(temp, this.lastMonthEndDate, true).concat(
        this.numberList(1, 7 - this.currentMonthFirstDay)
      )
      this.list.push(list)
      temp = 7 - this.currentMonthFirstDay + 1
      /* 剩下的行数 */
      // 计算除了第一行剩下的天数
      const leftDays =
        this.currentMonthEndDate - (7 - this.currentMonthFirstDay)
      // 剩下的星期数
      const lineNumber = Math.ceil(leftDays / 7)
      // 包含下个月日历的天数
      const nextDays = 7 - (leftDays % 7)
      for (let i = 0; i < lineNumber; i++) {
        if (i === lineNumber - 1 && nextDays > 0 && nextDays !== 7) {
          this.list[lineNumber] = this.numberList(
            temp,
            this.currentMonthEndDate
          ).concat(this.numberList(1, nextDays, true))
        } else {
          this.list.push(this.numberList(temp, temp + 6))
        }
        temp = temp + 7
      }
      // 补齐6排
      if (lineNumber < 5) {
        this.list.push(this.numberList(nextDays + 1, nextDays + 7, true))
      }
    },
    /* 获得日历数组 start: 开始日 end: 结束日 flag： boolean值，判断是否属于本月 */
    numberList (start, end, flag) {
      let list = []
      for (let i = start; i <= end; i++) {
        list.push({
          text: i,
          flag: !!flag
        })
      }
      return list
    },
    /* 切换月份， -1为当前月份-1，+1为当前月份+1 */
    switchMonth (n) {
      let year = this.select.year
      if (n === -1) {
        const pre = this.select.month === 1 ? 12 : this.select.month - 1
        if (pre === 12) {
          this.transform(new Date(year - 1, pre - 1, this.select.date))
        } else {
          this.transform(new Date(year, pre - 1, this.select.date))
        }
      } else {
        const next = this.select.month === 12 ? 1 : this.select.month + 1
        if (next === 1) {
          this.transform(new Date(year + 1, next - 1, this.select.date))
        } else {
          this.transform(new Date(year, next - 1, this.select.date))
        }
      }
    },
    /* 切换年份， -1为当前年份-1，+1为当前年份+1 */
    switchYear (n) {
      if (this.selectYear) {
        let year = this.years[0]
        this.years = []
        if (n === -1) {
          for (var i = year - 10; i < year; i++) {
            this.years.push(i)
          }
        } else {
          for (var j = year + 10; j < year + 20; j++) {
            this.years.push(j)
          }
        }
      } else {
        let year = this.select.year
        if (n === -1) {
          this.transform(
            new Date(year - 1, this.select.month - 1, this.select.date)
          )
        } else {
          this.transform(
            new Date(year + 1, this.select.month - 1, this.select.date)
          )
        }
      }
    },
    pick (day) {
      if (day.flag) {
        // 当页日历上可能还会显示部分上个月或者下个月的部分天数，根据标识来做判断
        // 并对月份作出相应的处理
        if (parseInt(day.text) > 15) {
          this.transform(
            new Date(
              this.select.year,
              this.select.month - 2,
              parseInt(day.text)
            )
          )
        } else {
          this.transform(
            new Date(this.select.year, this.select.month, parseInt(day.text))
          )
        }
      } else {
        this.transform(
          new Date(this.select.year, this.select.month - 1, parseInt(day.text))
        )
      }
      this.complete()
      this.bindEvent()
    },
    // 绑定事件：点击关闭日历面板
    bindEvent () {
      this.show = false
      this.selectYear = false
      this.selectMonth = false
    },
    // 打开选择年份
    openSelectYear () {
      this.selectYear = !this.selectYear
      this.selectMonth = false
    },
    // 打开选择月份
    openSelectMonth () {
      this.selectMonth = !this.selectMonth
      this.selectYear = false
    },
    // 选取年
    pickYear (n) {
      // this.transform(new Date(n, this.select.month - 1, this.select.date))
      this.select.year = n
      this.selectYear = !this.selectYear
      this.selectMonth = true
      // this.complete()
    },
    // 选取月
    pickMonth (n) {
      // this.transform(new Date(this.select.year, n - 1, this.select.date))
      this.select.month = n
      this.selectMonth = !this.selectMonth
      // this.complete()
    },
    // 更改选中时间并向父组件派发事件
    complete () {
      // 触发父组件的传过来的picked事件。三个参数: 年，月，日
      this.$emit(
        'picked',
        this.select.year,
        this.select.month,
        this.select.date
      )
      this.current = {
        year: this.select.year,
        month: this.select.month,
        date: this.select.date
      }
    },
    checkOffsetBottom () {
      let scrollTop =
        (document.documentElement && document.documentElement.scrollTop) ||
        document.body.scrollTop
      let clientHeight =
        (document.documentElement && document.documentElement.clientHeight) ||
        document.body.clientHeight
      let offsetBottom =
        clientHeight -
        (this.$refs['agm-datepicker'].offsetTop -
          scrollTop +
          this.$refs['agm-datepicker'].offsetHeight)
      offsetBottom < 250
        ? (this.positionTop = true)
        : (this.positionTop = false)
    },
    uploadFile: function (file) {
      console.log(file)
      if (file && file.size <= 1024 * 1024 * 10 && this.registerData.filesUrl.length < 3) {
        var item = {
          name: file.name,
          file: file,
          uploadPercentage: 0
        }
        this.registerData.files.push(item)
        this.updateFile(item)
      } else if (this.registerData.filesUrl.length >= 3) {
        alert('最多上传三个文件!')
      } else {
        alert('请选择文件且文件大小不能超过 10MB!')
      }
    },
    uploadFile2: function (event) {
      console.log(this.$refs.files.files[0])
      event.preventDefault()
      if (this.$refs.files.files[0] && this.$refs.files.files[0].size < 1024 * 1024 * 10 && this.registerData.filesUrl.length < 3) {
        var item = {
          name: this.$refs.files.files[0].name,
          file: this.$refs.files.files[0],
          uploadPercentage: 0
        }
        this.registerData.files.push(item)
        this.updateFile(item)
      } else if (this.registerData.filesUrl.length >= 3) {
        alert('最多上传三个文件!')
      } else {
        alert('请选择文件且文件大小不能超过 10MB!')
      }
    },
    onDrag: function (e) {
      e.stopPropagation()
      e.preventDefault()
    },
    onDrop: function (e) {
      e.stopPropagation()
      e.preventDefault()
      var dt = e.dataTransfer
      if (dt.files.length + this.registerData.filesUrl.length > 3) {
        alert('最多上传三个文件!')
        return
      }
      for (var i = 0; i !== dt.files.length; i++) {
        this.uploadFile(dt.files[i])
      }
    },
    updateFile (item) {
      let self = this
      // let files = document.getElementById('file1').files[0]
      let files = item.file
      let param = new FormData()
      param.append('file', files)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      }
      // this.$http.upload('https://www.gwcevents.com/SpeakerorSponser/UploadAvatar', files).then(response => {
      //   console.log(response.data)
      // })
      axios.post('http://127.0.0.1:8003/v2/registration/upload_file', param, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          let complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
          item.uploadPercentage = complete - 1
        }
      }).then(response => {
        if (response.data.url) {
          item.uploadPercentage = 100
        }
        self.registerData.filesUrl.push(response.data.url)
      })
    },
    deleteFile: function (i) {
      // console.log(this.registerData.files)
      this.registerData.files.splice(i, 1)
      this.registerData.filesUrl.splice(i, 1)
    },
    register: function () {
      let self = this
      console.log(self.registerData.filesUrl)
      // self.$validator.validate().then(result => {
      //   if (result) {
      //     self.isLoading = true
      //     self.$http.post('http://127.0.0.1:8003/v2/registration/add', {
      //       name: self.registerData.name,
      //       gender: self.registerData.sex,
      //       email: self.registerData.email,
      //       wechat: self.registerData.email,
      //       mobile: self.registerData.tel,
      //       birthday: self.current,
      //       assistant: self.registerData.asstel,
      //       company: self.registerData.company,
      //       title: self.registerData.title,
      //       company_intro: self.registerData.files,
      //       referee_id: 2,
      //       referee_name: self.registerData.tjname,
      //       q_achievement: self.registerData.achievement,
      //       q_life: self.registerData.life,
      //       q_personbook: self.registerData.book,
      //       q_target: self.registerData.target,
      //       q_english: self.registerData.englishLevel,
      //       q_channel: self.registerData.way,
      //       edu_college_name: self.registerData.schoolname,
      //       edu_degree: self.registerData.xl,
      //       edu_major: self.registerData.zy,
      //       edu_date: self.registerData.qzsj,
      //       edu_training: self.registerData.cy
      //     })
      //       .then(function (res) {
      //         // console.log(res.data.id)
      //         var id = res.data.id
      //         self.isLoading = false
      //         self.isSuccess = true
      //         self.timer = setInterval((id) => {
      //           self.$router.push({
      //             name: 'registration',
      //             params: {
      //               data: id
      //             }
      //           })
      //           clearInterval(self.timer)
      //         }, 3000)
      //       })
      //       .catch(function (error) {
      //         console.log(error)
      //         self.isLoading = false
      //       })
      //   }
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/registration/registration.page.vue